import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { OrderedMap, Map } from "immutable";
import { 
    Form,
    // Icon,
    List
} from "antd";
import { fieldGenerator, getErrorOnField, submitForm } from "utilities/form";
import { AddressRecord, AssociateRecord } from "records/company-record";
import { CAB_ENGINE_OVERALL_PARAMETERS } from "constants/form-fields";
// import moment from "moment";
import "styles/form.css";

const ListItem = List.Item;

class CamEngineForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    onChangeValues = () => {
        // this.props.onValuesChange(
        //     new AssociateRecord({ ...name, ...restValues }),
        //     new AddressRecord({
        //         ...residence_address,
        //         associate: restValues.associate
        //     })
        // );
    };
    getFormField(fieldName, field) {
        return this.fieldGenerator(
            fieldName,
            {...field},
            this.getErrorOnField(fieldName)
        )();
    }

    // setShareholding = val => {
    //     if (val === 1) {
    //         this.props.form.setFieldsValue({ shareholding: 100 });
    //     }
    // };
    render() {
        console.log("values", this.props.overallData);
        return (
            <Form
                layout="vertical"
                hideRequiredMark={false}
                className={cx("form-vertical", "f-grow-1", "br-3")}
                // onValuesChange={this.onChangeValues}
                onSubmit={this.handleFormSubmit}>
                <List bordered className={"tabled-list"}>
                    {CAB_ENGINE_OVERALL_PARAMETERS.map((field, fieldName) => {
                        return (
                            <ListItem
                                className={"form-field-list-item"}
                                key={fieldName}>
                                {this.getFormField(fieldName, field)}
                            </ListItem>
                        );
                    }).toList()}
                </List>
            </Form>
        );
    }
}

CamEngineForm.propTypes = {
    overallData: PropTypes.object
};

export default Form.create({})(CamEngineForm);
